/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemTypeSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  color: z.string().nullish(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  description: z.string().nullish(),
  icon: z.string().nullish(),
  id: z.int(),
  itemLevelId: z.int(),
  name: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
